export default __webpack_public_path__ + "7a397ab715e1cf4cbcbbefedf0ab2724.jpg";